import React, { useState } from 'react';

import {
    Box,
    Typography,
    Button,
    TextField
} from "@mui/material";

const AssignmentInstructions = ({ instructions, setInstructions, setActiveStep }) => {
    const [editInstructions, setEditInstructions] = useState(instructions);
    const maxCharacters = 250;

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setInstructions(editInstructions);
    };

    const handleInstructionsChange = (event) => {
        setEditInstructions(event.target.value);
    };

    const charactersRemaining = maxCharacters - editInstructions.length;
    const isError = charactersRemaining < 0;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 6 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="h5" sx={{ flexGrow: 1 }}>Provide Instructions</Typography>
            </Box>
            <Typography variant="body1" sx={{ mb: 4, pl: '100px', pr: '100px' }}>
                The instructions you add will appear in your students’ apps. 
            </Typography>

            <TextField
                multiline
                rows={9}
                variant="outlined"
                placeholder="Read and listen at the same time. If it is too difficult, decrease the audio speed. Feel free to use the translations, glossary, and commentaries. Take notes of difficulties. We’ll discuss them in class. Good luck!"
                value={editInstructions}
                onChange={handleInstructionsChange}
                fullWidth
                sx={{ mt: 2, mb: 3, maxWidth: '500px' }}
                helperText={`${editInstructions.length}/${maxCharacters}`}
                FormHelperTextProps={{
                    sx: {
                        position: 'absolute',
                        bottom: '10px',
                        right: '10px',
                        color: isError ? 'error.main' : 'text.secondary'
                    }
                }}
                error={isError}
            />

            <Button
                variant="contained"
                color="primary"
                sx={{ mt: 3, mb: 2 }}
                onClick={handleNext}
                disabled={isError}
            >
              Continue
            </Button>
        </Box>
    );
};

export default AssignmentInstructions;
